import React from "react";
export default function DotIcon(){
    return <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="3" height="3" rx="1.5" fill="#212529"/>
</svg>
}
